import PropTypes from 'prop-types';
import { Colors } from '../../../themes/colors';

// Feature palette — sourced from the shared theme where a token exists; the
// remaining values are ProPrograms-specific (Admin-Panel-Master-Flow, node
// 6839-489) with no theme equivalent (light-blue header, Bootstrap-info CTA).
export const COLORS = {
  text: Colors.neutral_800,
  rowBg: Colors.neutral_50,
  border: Colors.divider,
  secondary: Colors.secondary_500,
  headerBg: '#ADD8E6',
  cardBorder: 'rgba(0, 0, 0, 0.13)',
  addButtonBg: '#5BC0DE',
  addButtonBorder: '#46B8DA',
};

// Shared 4-column layout so the blue header aligns with each expanded batch row:
// Date | Uploaded by | Payout Succeeded | Payout Failed.
export const PAYOUT_GRID_COLUMNS = '40% 26% 20% 14%';

// Shared table cell styles for the payout review / summary / history tables.
export const thStyle = {
  padding: '8px 12px',
  fontWeight: 700,
  fontSize: 14,
  color: COLORS.text,
  textAlign: 'left',
};

export const tdStyle = { padding: '8px 12px', fontSize: 14, color: COLORS.text };

// Hard per-line ceiling for a promotion's max payout (guards against typos).
export const MAX_PROMOTION_VALUE = 10000;

// Shared shape for a promotion across the ProPrograms components.
export const promotionPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  maxValueDisplay: PropTypes.string,
  maxValueCents: PropTypes.number,
  isDisabled: PropTypes.bool,
});
